module.exports = __webpack_public_path__ + "img/img13.1da1a2dc.svg";